import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_update_aso_report",
  ref: "updateAsoReportModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1200px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_update_aso_report_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  id: "kt_modal_update_aso_report_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_update_aso_report_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_update_aso_report_header",
  "data-kt-scroll-wrappers": "#kt_modal_update_aso_report_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "d-flex flex-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-row-auto w-200px" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column-auto h-60px" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold me-5" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "fs-6 required" }, "Period")
    ])
  ])
], -1)
const _hoisted_12 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_13 = { class: "d-flex flex-column-auto h-40px" }
const _hoisted_14 = { class: "d-flex flex-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-row-auto w-200px" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column-auto h-60px" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold me-5" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "fs-6 required" }, "Countries")
    ])
  ])
], -1)
const _hoisted_16 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_17 = { class: "d-flex flex-column-auto h-40px" }
const _hoisted_18 = { class: "d-flex flex-row" }
const _hoisted_19 = { class: "d-flex flex-column flex-row-auto w-200px" }
const _hoisted_20 = { class: "d-flex flex-column-auto h-60px" }
const _hoisted_21 = { class: "fw-bold me-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6" }, "AppTweak", -1)
const _hoisted_23 = { class: "fs-7 text-gray-400" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_26 = { class: "d-flex flex-column-auto h-40px" }
const _hoisted_27 = { class: "form-check form-check-custom form-check-solid me-5 w-175px" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, "Categories", -1)
const _hoisted_29 = { class: "form-check form-check-custom form-check-solid w-200px" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, "Keywords", -1)
const _hoisted_31 = { class: "d-flex flex-column-auto h-40px" }
const _hoisted_32 = { class: "form-check form-check-custom form-check-solid me-5 w-175px" }
const _hoisted_33 = { class: "form-check-label fw-bold" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Reviews ")
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  style: {"margin-left":"4px","cursor":"pointer"}
}, null, -1)
const _hoisted_36 = { class: "form-check form-check-custom form-check-solid w-200px" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, "Downloads", -1)
const _hoisted_38 = { class: "d-flex flex-column-auto h-40px" }
const _hoisted_39 = { class: "form-check form-check-custom form-check-solid me-5 w-175px" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Include Competitors ", -1)
const _hoisted_41 = { class: "d-flex flex-row" }
const _hoisted_42 = { class: "d-flex flex-column flex-row-auto w-200px" }
const _hoisted_43 = { class: "d-flex flex-column-auto h-40px" }
const _hoisted_44 = { class: "fw-bold me-5" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6" }, "Console", -1)
const _hoisted_46 = { class: "fs-7 text-gray-400" }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_49 = { class: "d-flex flex-row h-40px" }
const _hoisted_50 = { class: "form-check form-check-custom form-check-solid me-5 w-175px" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, "Metrics", -1)
const _hoisted_52 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid w-200px"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Metrics By Country ", -1)
const _hoisted_54 = {
  key: 0,
  class: "d-flex flex-row h-40px"
}
const _hoisted_55 = { class: "form-check form-check-custom form-check-solid me-5 w-175px" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, "Acquisition", -1)
const _hoisted_57 = { class: "form-check form-check-custom form-check-solid w-200px" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Acquisition By Country ", -1)
const _hoisted_59 = { class: "d-flex flex-row h-40px" }
const _hoisted_60 = { class: "form-check form-check-custom form-check-solid me-5 w-175px" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, "Subscriptions", -1)
const _hoisted_62 = {
  key: 1,
  class: "d-flex flex-row h-40px"
}
const _hoisted_63 = { class: "form-check form-check-custom form-check-solid me-5 w-175px" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, "Include WW", -1)
const _hoisted_65 = { class: "d-flex flex-row" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-row-auto w-200px" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column-auto h-40px" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold me-5" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "fs-6" }, "Queue as Job")
    ])
  ])
], -1)
const _hoisted_67 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_68 = { class: "d-flex flex-row h-40px" }
const _hoisted_69 = {
  key: 0,
  class: "d-flex flex-row h-40px"
}
const _hoisted_70 = { class: "modal-footer flex-center" }
const _hoisted_71 = ["data-kt-indicator"]
const _hoisted_72 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_74 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_75 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, "Update ASO Report: " + _toDisplayString(_ctx.asoproject.name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.dates,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dates) = $event)),
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "Start date",
                        "end-placeholder": "End date",
                        format: "DD/MM/YYYY",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_form_item, { prop: "countries" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.countries,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.countries) = $event)),
                            type: "text",
                            placeholder: "Comma separated list"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("a", {
                            href: _ctx.asoproject.aso_spreadsheet,
                            target: "_blank"
                          }, " View ASO Spreadsheet ", 8, _hoisted_24)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input h-20px w-20px",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.options) = $event)),
                          id: "apptweak_categories",
                          value: "apptweak_categories"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.formData.options]
                        ]),
                        _hoisted_28
                      ]),
                      _createElementVNode("label", _hoisted_29, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input h-20px w-20px",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.options) = $event)),
                          id: "apptweak_keywords",
                          value: "apptweak_keywords"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.formData.options]
                        ]),
                        _hoisted_30
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input h-20px w-20px",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.options) = $event)),
                          id: "apptweak_reviews",
                          value: "apptweak_reviews"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.formData.options]
                        ]),
                        _createElementVNode("span", _hoisted_33, [
                          _hoisted_34,
                          _createVNode(_component_el_tooltip, {
                            content: "This option takes a long time to execute. Only check it if you need it. Try to keep the Reviews tab in the Google Sheet as empty as possible.",
                            placement: "top",
                            "open-delay": "0"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_35
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_36, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input h-20px w-20px",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.options) = $event)),
                          id: "apptweak_downloads",
                          value: "apptweak_downloads"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.formData.options]
                        ]),
                        _hoisted_37
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input h-20px w-20px",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.options) = $event)),
                          id: "apptweak_competitors",
                          value: "apptweak_competitors"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.formData.options]
                        ]),
                        _hoisted_40
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("a", {
                            href: _ctx.asoproject.console_spreadsheet,
                            target: "_blank"
                          }, " View Console Spreadsheet ", 8, _hoisted_47)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input h-20px w-20px",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.options) = $event)),
                          id: "console_metrics",
                          value: "console_metrics"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.formData.options]
                        ]),
                        _hoisted_51
                      ]),
                      (_ctx.isAndroid)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_52, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input h-20px w-20px",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.options) = $event)),
                              id: "console_metrics_by_country",
                              value: "console_metrics_by_country"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.formData.options]
                            ]),
                            _hoisted_53
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.isAndroid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("label", _hoisted_55, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input h-20px w-20px",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.options) = $event)),
                              id: "console_acquisition",
                              value: "console_acquisition"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.formData.options]
                            ]),
                            _hoisted_56
                          ]),
                          _createElementVNode("label", _hoisted_57, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input h-20px w-20px",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.options) = $event)),
                              id: "console_acquisition_by_country",
                              value: "console_acquisition_by_country"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.formData.options]
                            ]),
                            _hoisted_58
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("label", _hoisted_60, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input h-20px w-20px",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.options) = $event)),
                          id: "console_subscriptions",
                          value: "console_subscriptions"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.formData.options]
                        ]),
                        _hoisted_61
                      ])
                    ]),
                    (!_ctx.isAndroid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createElementVNode("label", _hoisted_63, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input h-20px w-20px",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.options) = $event)),
                              id: "console_include_ww",
                              value: "console_include_ww"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.formData.options]
                            ]),
                            _hoisted_64
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.job,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.job) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booleanSelect, (option) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: option.id,
                              label: option.name,
                              value: option.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    (_ctx.formData.job)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _createVNode(_component_el_form_item, { prop: "job_name" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.job_name,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.job_name) = $event)),
                                type: "text",
                                placeholder: "Job Name"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                      _hoisted_73,
                      _createElementVNode("span", _hoisted_74, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_75, _hoisted_78))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_71)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}